import Page from "webPage/Page";
import Track from "util/Track";
import StickySection from "util/StickySection";

Page.register('single-post', () => {
    let $track = $(".js-track-wrap");

    if ($track.length > 0) {
        new Track($track, {
            classes: {
                block: "card-slider",
            },
        });
    }

    $("body").on('click', '.js-toggle-categories', function () {
        if($(window).outerWidth() < 600){
            $(this).closest('.inner-categories').toggleClass('inner-categories--active');
        }
    });

    if ($('.js-article-content').outerHeight() > $('.js-sticky-header').outerHeight()) {
        new StickySection($('.js-sticky-section'), 760);
    }
});